<template>
  <span>
    <a href="#" ref="copyToClipboard" class="pl-1" @click="onClick" :data-clipboard-text="value" data-testid="copy-link-to-clipboard">
      <img :src="require('@img/icons-clipboard.svg')" />
    </a>
    <span class="copied-message" v-if="success && !useFlash"><slot></slot></span>
    <span class="error-message" v-if="error && !useFlash">Could not copy</span>
  </span>
</template>

<style scoped lang="scss">
.copied-message {
  font-size: 0.8rem;
  color: rgb(13, 138, 13);
}
.error-message {
  font-size: 0.8rem;
  color: rgb(226, 146, 80);
}
</style>

<script>
import ClipboardJS from 'clipboard'
import track from '@/src/tracking';

export default {
  mounted() {
    const vm = this;
    if (vm.container) {
      // This is used because ClipboardJS relies on the currently focused element. If loaded from within a
      // bootstrap modal, pass its id. It would be ideal if we could pass a ref or element instead of an
      // id, but not sure if that's a thing.
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard, { container: document.getElementById(vm.container) });
    } else {
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard);
    }

    vm.clipboard.on('success', function() { vm.success = true; vm.showSuccess(); });
    vm.clipboard.on('error', function() { vm.error = true; vm.showError(); });

    if (this.trackAchievements) { track('open_share_item_modal', { source: "explore_features_modal" }) }
  },
  props: {
    value: String,
    container: String,
    trackAchievements: {
      type: Boolean,
      default: false
    },
    useFlash: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      success: false,
      error: false,
      clipboard: null
    }
  },
  computed: {
    message: function () {
      return "Copy link";
    },
  },
  methods: {
    showSuccess: function() {
      if (this.useFlash) {
        return this.showFlash("success", "Share link copied to clipboard");
      }
      setTimeout(this.hideMessage, 3000);
    },
    showError: function() {
      if (this.useFlash) {
        return this.showFlash("danger", "Could not copy share link");
      }
      setTimeout(this.hideMessage, 3000);
    },
    showFlash: function(status, message) {
      $(`.flash.alert-${status}`)
        .text(message)
        .fadeIn(500, function() {
          $(this).delay(1000).fadeOut();
      });
    },
    hideMessage: function() {
      this.success = false;
      this.error = false;
    },
    onClick: function() {
      this.sendTrackEvent();
    },
    sendTrackEvent: function () {
      track('viewer_copy_link_click', { source: "new_copy_viewer" });
    },
  }
}
</script>
